/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Secondreminderleadtime3Inputs */

const en__field_secondreminderleadtime3 = /** @type {(inputs: _Field_Secondreminderleadtime3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Second Reminder x Days ahead`)
};

const de__field_secondreminderleadtime3 = /** @type {(inputs: _Field_Secondreminderleadtime3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweite Erinnerung x Tage vorher`)
};

/**
* | output |
* | --- |
* | "Second Reminder x Days ahead" |
*
* @param {_Field_Secondreminderleadtime3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_secondreminderleadtime3 = /** @type {((inputs?: _Field_Secondreminderleadtime3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Secondreminderleadtime3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_secondreminderleadtime3(inputs)
	return de__field_secondreminderleadtime3(inputs)
});
export { _field_secondreminderleadtime3 as "_field_secondReminderLeadTime" }